module.exports = __webpack_public_path__ + "assets/img/f180c58d39a57eebd3f5880d8ee2d903.svg";